var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1463,
    cy: 11.8538,
    r: 11.8538,
    fill: "#394577"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2071 0V11.3417M12.3558 23.7694L12.2071 11.3417M12.2071 11.3417H23.9996H0M9.2608 0.205214C3.50161 4.65983 5.42516 16.5 10.7703 23.7694M14.8982 23.4686C17.0029 20.9854 22.8808 10.5106 15.3541 0.412036M0 9.52648C3.26274 6.78711 13.6412 1.73528 23.8382 9.19843M0.27273 13.5178C3.30162 15.7449 11.4537 20.4615 23.9996 14.1739",
    stroke: "#F0F2F9",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.913349d3f2ddac4caf6e9ace56deb6d8.svg";
export { ForwardRef as ReactComponent };